import {environment} from '../../../environments/environment';

export const serasaPublicData: any = {
  name: 'Serasa Experian',
  _id: '5e4b05a59c1aa2231b023535'
};

export const SYDLEClientID: string = environment.sydle_client_id;

